<div class="vol-container content">
  <div class="menu-bar">
    Volatility Surface
    <div>
      <button
        class="menu-bar--right-button-close"
        (click)="closeWidget()"
      ></button>
    </div>
  </div>

  <div class="vol-container__selection-row" style="line-height: 0.6rem">
    <div class="vol-container__selector">
      <app-selector
        [passedItems]="currencyPairs"
        [isSearch]="true"
        [defaultValue]="currencyPairs[0]"
        (valueEmitter)="onCurrencyPairChanged($event.value)"
      ></app-selector>
    </div>

    <!-- <clr-select-container>
      <select clrSelect [(ngModel)]="position">
        <option value="bid">Bid</option>
        <option value="ask">Ask</option>
      </select>
    </clr-select-container> -->

    <div class="vol-container__selector">
      <app-selector
        [passedItems]="['Bid', 'Ask']"
        [isSearch]="false"
        [defaultValue]="'Bid'"
        (valueEmitter)="position = $event.value.toLowerCase()"
      ></app-selector>
    </div>
  </div>
  <div class="vol-container__table--wrapper">
    <table ui-table *ngIf="dataLoaded | async">
      <thead>
        <tr>
          <th>Tenor</th>
          <th>10P</th>
          <th>25P</th>
          <th>ATMF</th>
          <th>25C</th>
          <th>10C</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let period of periods">
          <td>{{ periodToLabel[period] }}</td>

          <td
            [ngClass]="[
              'number-cell',
              'ui-value-color',
              data[period][90][position]
                | ValueColorsHeapMap: minValue : maxValue : meanValue
            ]"
          >
            {{ data[period][90][position] | number: '1.3-3' }}
          </td>

          <td
            [ngClass]="[
              'number-cell',
              'ui-value-color',
              data[period][75][position]
                | ValueColorsHeapMap: minValue : maxValue : meanValue
            ]"
          >
            {{ data[period][75][position] | number: '1.3-3' }}
          </td>

          <td
            [ngClass]="[
              'number-cell',
              'ui-value-color',
              data[period][50][position]
                | ValueColorsHeapMap: minValue : maxValue : meanValue
            ]"
          >
            {{ data[period][50][position] | number: '1.3-3' }}
          </td>

          <td
            [ngClass]="[
              'number-cell',
              'ui-value-color',
              data[period][25][position]
                | ValueColorsHeapMap: minValue : maxValue : meanValue
            ]"
          >
            {{ data[period][25][position] | number: '1.3-3' }}
          </td>

          <td
            [ngClass]="[
              'number-cell',
              'ui-value-color',
              data[period][10][position]
                | ValueColorsHeapMap: minValue : maxValue : meanValue
            ]"
          >
            {{ data[period][10][position] | number: '1.3-3' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div *ngIf="marketDataErrorMsg" class="vol-container__error">
    {{ marketDataErrorMsg }}
  </div>
</div>
